import { erc20Abi } from "viem"

const abi = erc20Abi

export default abi

export const address = "0x7b7C000000000000000000000000000000000000"
